import { Button } from "@chakra-ui/react/button";
import { useBreakpointValue } from "@chakra-ui/react/hooks";
import { HStack } from "@chakra-ui/react/stack";
import { Text } from "@chakra-ui/react/text";
import { Alert } from "components/ui/alert";

import { MerchantUserGuides } from "entities/domain/admin/merchants/merchant-user-guides";
import React, { useEffect, useState } from "react";
import { useMerchant } from "hooks/queries/use-settings-merchant";
import { useNavigate } from "react-router-dom";
import {
  OnboardingStatus,
  setOnboardingStatus,
} from "redux/features/onboarding";
import { useAppDispatch, useAppSelector } from "redux/hooks";

type PageBannerProps = {};

const PageBanner = (_props: PageBannerProps) => {
  const dispatch = useAppDispatch();
  const { data: merchant } = useMerchant();
  const { colorScheme } = useAppSelector((state) => state.theme);
  const { status } = useAppSelector((state) => state.onboarding);
  const isBaseSize = useBreakpointValue(
    { base: true, md: false },
    { ssr: false }
  );
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isOnboardingPending = merchant.userGuides.pending.includes(
      MerchantUserGuides.ONBOARDING
    );
    const isOnboardingPaused = status === OnboardingStatus.PAUSED;

    if (
      (isOnboardingPending && isOnboardingPaused) ||
      (isOnboardingPending && !window.location.pathname.includes("inbox"))
    ) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [status, merchant.userGuides.pending, window.location.pathname]);

  return !isOpen ? null : (
    <Alert
      status="warning"
      variant="subtle"
      position="absolute"
      top={0}
      zIndex={9999}
      alignItems="center"
      onClose={() => setIsOpen(false)}
      closable={true}
      title={
        <HStack>
          <Text>You haven&apos;t completed your onboarding yet!</Text>
          <Button
            colorPalette="yellow"
            size="xs"
            variant="subtle"
            onClick={() => {
              navigate(`/${merchant.id}/inbox`);
              dispatch(setOnboardingStatus(OnboardingStatus.IN_PROGRESS));
            }}
          >
            Please click here to continue.
          </Button>
        </HStack>
      }
    />
  );
};

export default PageBanner;
